import { useState } from "react";
import { Drawer, Form } from "antd";
import { permission } from "../../../API/UserManagement/Permission";
import ReusableForm from "../../../unity-ui-common/Components/ReForm";
import ReInput from "../../../unity-ui-common/Components/ReFormFields/ReInput";
import * as Styles from "./ManagePrivilegesStyles";

type TempPermissionsType = {
  name: string;
  description: string;
  type: number | string;
};

type propsType = {
  visibility: boolean;
  setVisibility: Function;
}

function PrivilegesManagement(props: propsType) {

  const [form] = Form.useForm();
  const { visibility, setVisibility } = props;
  const [tempPermissions, setTempPermissions] = useState<TempPermissionsType>({
    name: "",
    description: "",
    type: "",
  });

  const flushStateData = () => {
    setTempPermissions({
      name: "",
      description: "",
      type: "",
    });
  };

  const onClose = () => {
    setVisibility(false);
    flushStateData();
    form.resetFields();
  };

  const addPermissions = async (values: any) => {
    const payload = {
      ...values,
      type: values.type !== undefined && values.type !== "" ? Number(values.type) : undefined,
    };
    await permission.create(payload);
    // dispatch(getAllPermission());
    setVisibility(false);
    form.resetFields();
  };

  return (
    <Styles.Container>
      <Drawer placement="right" onClose={onClose} open={visibility}>
        <ReusableForm
          formInstance={form}
          onSubmit={addPermissions}
          submitBtn
        >
          <ReInput
            label="Name"
            name="name"
            required
            type="simple"
          />
          <ReInput
            label="Description"
            name="description"
            required
            type="simple"
          />
          <ReInput
            label="Type (numeric)"
            name="type"
            required
            type="simple"
          />
        </ReusableForm>
      </Drawer>
    </Styles.Container>
  );
}

export default PrivilegesManagement;